import React, { useState, useEffect } from "react";
import axios from 'axios'
import toast from "react-hot-toast";
import { FaSearch, FaUserCheck } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

function Support({ token }) {
    const [searchTerm, setSearchTerm] = useState('');
    const [list, setList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [remark, setRemark] = useState("");
    const [loading, setLoading] = useState(false);
    const [showCloseModal, setShowCloseModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDelete, setSelectedDelete] = useState(null);


    const fetchTicket = async () => {
        try {
            const res = await axios.get(
                `https://api.krimotion.in/fetch-ticket`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setList(res.data);
          
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchTicket();

    }, []);

    const closeTicket = async () => {
        try {
            await axios.put(
                `https://api.krimotion.in/close-ticket/${selectedTicket.id}`,
                {
                    remark,
                    status: 'Closed',
                    resolved_on: new Date().toISOString().slice(0, 19).replace("T", " "),
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setShowCloseModal(false);
            setRemark("");
            fetchTicket();
            toast.success("Ticket closed  successfully.");

        } catch (error) {
            console.log(error);
            toast.error("Fail to closed ticket.");
            setShowCloseModal(false);
        }
    };


     const handleDeleteEnquiry = async () => {
  try {
    const res = await axios.delete(
      `https://api.krimotion.in/delete-support-enquiry/${selectedDelete.id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    toast.success(res.data.message);

    setShowDeleteModal(false);
    setSelectedDelete(null);

        fetchTicket();
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};


    const filteredData = Array.isArray(list)
        ? list.filter(itm =>
            Object.values(itm).some(val =>
                String(val).toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
        : [];

const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; 
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};
    return (
        <div>
            <div className="container py-4">
                <div className="border-0  mb-3 px-2 py-2  ">

                    <div className="d-flex flex-column gap-2">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                            <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
                                Help & Support
                            </h4>

                            <div style={{ flex: 1, maxWidth: "250px" }}>
                                <div
                                    className="d-flex align-items-center rounded-pill overflow-hidden"
                                    style={{
                                        border: "1px solid var(--green)",
                                        height: "34px",
                                        paddingLeft: "8px",
                                        paddingRight: "8px",
                                        backgroundColor: "white"
                                    }}
                                >
                                    <FaSearch style={{ color: "var(--green)", fontSize: "14px" }} />

                                    <input
                                        type="text"
                                        className="form-control border-0 shadow-none"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        style={{
                                            fontSize: "14px",
                                            height: "32px",
                                            marginLeft: "6px"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* {!showForm && (
                    <>
                        <div className="card shadow-lg border-0 rounded-4 mt-4 overflow-hidden " style={{ background: '#f4f6f9' }}>

                            <div className="card-body p-3">
                                <div className="table-responsive">
                                    <table className="table table-hover align-middle mb-0 text-center">
                                        <thead  >
                                            <tr>
                                                <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Customer Name</th>
                                                <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Problem</th>
                                                <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Status</th>
                                                <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Solution</th>
                                                <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Raised Date</th>
                                                <th className=" text-white" style={{ backgroundColor: 'var(--green)' }}>Status </th>


                                            </tr>
                                        </thead>

                                        <tbody>
                                            {filteredData.length > 0 ? (
                                                filteredData.map((dealer, index) => (
                                                    <tr key={index}>
                                                        <td>{dealer.raised_by_name}</td>
                                                        <td >{dealer.description}</td>
                                                        <td>
                                                            <span
                                                                className={`status-badge ${dealer.status === "Pending"
                                                                        ? "status-warning"
                                                                        : "status-success"
                                                                    }`}
                                                            >
                                                                {dealer.status}
                                                            </span>
                                                        </td>
                                                        <td>{dealer.remark}</td>

                                                        <td>{formatDate(dealer.raised_on)}</td>
                                                        <td>
                                                            <div className="d-flex gap-2">

                                                           
                                                            {dealer.status === "Pending" ? (
                                                                <button
                                                                    className="btn-action btn-danger-custom"
                                                                    onClick={() => {
                                                                        setSelectedTicket(dealer);
                                                                        setRemark("");
                                                                        setShowCloseModal(true);
                                                                    }}
                                                                >
                                                                    Not Solved
                                                                </button>
                                                            ) : (
                                                                <button className="btn-action btn-success-custom" disabled>

                                                                    Resloved
                                                                </button>
                                                            )}

                                                               <MdDeleteForever
                                                              size={26}
                                                              title="Delete Enquiry"
                                                              className="text-danger"
                                                              style={{ cursor: "pointer" }}
                                                              onClick={() => {
                                                                setSelectedDelete(dealer);
                                                                setShowDeleteModal(true);
                                                              }}
                                                            />

                                                             </div>
                                                        </td>




                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-4">
                                                        No List Found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>
                            </div>



                        </div>

                    </>
                )} */}


                {!showForm && (
  <div className="container-fluid mt-4">
<div className="row g-4">

{filteredData.map((dealer,index)=>(
<div className="col-lg-6" key={index}>

<div className="inventory-card d-flex flex-column h-100">

    {/* Header */}
    <div className="d-flex justify-content-between align-items-center">

        <div>
            <h5 className="fw-bold mb-0">
                {dealer.raised_by_name}
            </h5>

            <small className="text-muted">
                {formatDate(dealer.raised_on)}
            </small>
        </div>

        <span
            className={`status-badge ${
                dealer.status==="Pending"
                ? "status-warning"
                : "status-success"
            }`}
        >
            {dealer.status}
        </span>

    </div>

    <hr/>

    {/* Problem */}

    <div className="mb-3">
<div className="fw-bold  mb-2">
    Request Submitted By: <span className="text-primary"> {dealer.user_type} </span>
</div>
        <div className="fw-bold text-danger mb-2">
            Problem
        </div>

        <div className="support-box">
            {dealer.description}
        </div>

    </div>

    {/* Solution */}

    <div className="mb-3">

        <div className="fw-bold text-success mb-2">
            Solution
        </div>

        <div className="support-box">

            {dealer.remark
                ? dealer.remark
                : "No solution added yet."}

        </div>

    </div>

    {/* Bottom */}

    <div className="mt-auto d-flex justify-content-between align-items-center">

        {dealer.status==="Pending" ? (

            <button
                className="btn-action btn-danger-custom"
                onClick={()=>{
                    setSelectedTicket(dealer);
                    setRemark("");
                    setShowCloseModal(true);
                }}
            >
                Resolve
            </button>

        ) : (

            <button
                className="btn-action btn-success-custom"
                disabled
            >
                Resolved
            </button>

        )}

        <MdDeleteForever
            size={28}
            className="text-danger"
            style={{cursor:"pointer"}}
            onClick={()=>{
                setSelectedDelete(dealer);
                setShowDeleteModal(true);
            }}
        />

    </div>

</div>

</div>
))}

</div>
  </div>
)}


                                            {showCloseModal && (
                                <div
                                    className="modal d-block"
                                    style={{
                                        background: "rgba(0,0,0,.55)",
                                        backdropFilter: "blur(5px)",
                                        zIndex: 9999,
                                    }}
                                >
                                    <div className="modal-dialog modal-dialog-centered ">
                                        <div
                                            className="modal-content border-0 shadow-lg"
                                            style={{ borderRadius: "18px" }}
                                        >
                                            {/* Header */}
                                            <div
                                                className="position-relative text-center py-4"
                                                style={{
                                                    background: "linear-gradient(135deg,#0d6efd,#0dcaf0)",
                                                }}
                                            >
                                                <button
                                                    className="btn btn-light btn-sm position-absolute"
                                                    style={{
                                                        right: 15,
                                                        top: 15,
                                                        borderRadius: "50%",
                                                        width: 35,
                                                        height: 35,
                                                    }}
                                                    onClick={() => {
                                                        setShowCloseModal(false);
                                                        setRemark("");
                                                    }}
                                                >
                                                    ✕
                                                </button>

                                                <div
                                                    className="mx-auto d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: 70,
                                                        height: 70,
                                                        borderRadius: "50%",
                                                        background: "rgba(255,255,255,.2)",
                                                    }}
                                                >
                                                    <FaCheckCircle
                                                        size={35}
                                                        color="#fff"
                                                    />
                                                </div>

                                                <h4 className="text-white fw-bold mt-3 mb-0">
                                                    Close Support Ticket
                                                </h4>
                                            </div>

                                            {/* Body */}
                                            <div className="p-4">

                                                <div className="alert alert-warning border-0 shadow-sm">
                                                    <strong>Confirmation Required</strong>
                                                    <br />
                                                    You are about to mark this support ticket as
                                                    <strong> Closed</strong>.
                                                    <br />
                                                    Please provide a resolution remark before continuing.
                                                </div>

                                                <div className="bg-light rounded-3 p-3 mb-4">

                                                    <div className="d-flex justify-content-between">
                                                        <span>Raised By</span>
                                                        <strong>{selectedTicket?.raised_by_name}</strong>
                                                    </div>

                                                    <div className="d-flex justify-content-between mt-2">
                                                        <span>Ticket Status</span>

                                                        <span className="badge bg-warning text-dark">
                                                            {selectedTicket?.status}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between mt-2">
                                                        <span>Raised On</span>
                                                        <strong>{selectedTicket?.raised_on}</strong>
                                                    </div>

                                                </div>

                                                <div className="mb-3">
                                                    <label className="form-label fw-semibold">
                                                        Resolution Remark
                                                        <span className="text-danger">*</span>
                                                    </label>

                                                    <textarea
                                                        className="form-control"
                                                        style={{ height: "120px" }}
                                                        placeholder="Describe how the issue was resolved..."
                                                        value={remark}
                                                        onChange={(e) => setRemark(e.target.value)}
                                                    />
                                                </div>

                                            </div>

                                            {/* Footer */}
                                            <div className="px-4 pb-4 d-flex gap-3">
                                                <button
                                                    className="btn btn-outline-secondary w-50"
                                                    onClick={() => {
                                                        setShowCloseModal(false);
                                                        setRemark("");
                                                    }}
                                                >
                                                    Cancel
                                                </button>

                                                <button
                                                    className="btn btn-success w-50"
                                                    disabled={!remark.trim()}
                                                    onClick={closeTicket}
                                                >
                                                    <i className="bi bi-check-circle me-2"></i>
                                                    Mark as Closed
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                                                                {showDeleteModal && (
  <>
    <div
      className="modal-backdrop fade show"
      onClick={() => {
    setShowDeleteModal(false);
    setSelectedDelete(null);
  }}
    ></div>

    <div className="modal fade show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg"
          style={{ borderRadius: "16px" }}
        >
       
          <div className="modal-header bg-danger text-white">
            <h5 className="modal-title fw-bold">
              🗑 Delete Enquiry
            </h5>

            <button
              className="btn-close btn-close-white"
              onClick={() => setShowDeleteModal(false)}
            ></button>
          </div>

      
          <div className="modal-body text-center py-4">

            <div style={{ fontSize: "60px" }}>⚠️</div>

            <h5 className="mt-3 fw-bold">
              Are you sure?
            </h5>

            <p className="text-muted mb-0">
              You are about to permanently delete this enquiry.
            </p>

            <h6 className="fw-bold text-dark mt-2">
  {selectedDelete?.cust_name}
</h6>

            <p className="text-danger fw-semibold mt-2">
              This action cannot be undone.
            </p>

          </div>

       
          <div className="modal-footer border-0 justify-content-center">

            <button
              className="btn btn-outline-secondary px-4"
            onClick={() => {
    setShowDeleteModal(false);
    setSelectedDelete(null);
  }}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger px-4"
              onClick={handleDeleteEnquiry}
            >
              🗑 Delete
            </button>

          </div>

        </div>
      </div>
    </div>
  </>
)} 
            </div>
        </div>
    )
}

export default Support
